export default "__VITE_ASSET__BiR8n_zg__"